import React, { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import { Button, Select, Pagination, Spin, notification, Typography, Tooltip, Tabs, Row, Col } from 'antd';
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import get from 'lodash/get';
import { connect } from 'react-redux';
//ag grid enterprise
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { StatusBarModule } from "@ag-grid-enterprise/status-bar";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import moment from 'moment';
import { CustomLoadingCellRenderer, restoreGridLayout, saveGridLayout } from './Uitiles.js';

ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    MenuModule,
    SetFilterModule,
    StatusBarModule,
    RowGroupingModule,
    MultiFilterModule
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE)

const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const CommonAGGridTable = (props) => {
    const {
        rowData = [], // Accept rowData as prop with default empty array
        columnDefs = [], // Accept columnDefs as prop with default empty array
        isRawListLoading,
        isVisible,
        setIsVisible,
        tittle,
        activeKeyLine,
        onSelectionChanged: onSelectionChangedProp, // Accept selection change callback
        onRowDragEnd: onRowDragEndProp, // Accept row drag end callback
        onFilterChanged: onFilterChangedProp, // Accept filter change callback
        theme = 'ag-theme-alpine', // CRC Evans light theme default
        isPivotMode = false, // Accept pivot mode as prop with default
        loadingData = false, // Accept loading state as prop
        sideBar = false,
        totalTitle = 'Total ',
        loadingMessage = 'Loading...',
        filterData = [],
    } = props;

    const gridRef = useRef();
    const [currentSection, setCurrentSection] = useState('1');
    const [selectModel, setSelectModel] = useState([]);
    const [loadingRows, setLoadingRows] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [layoutSave, setLayoutSave] = useState(false);
    const [layoutLoad, setLayoutLoad] = useState(false);
    // Add these state variables at the top of your component
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage1, setLoadingMessage1] = useState('Loading data...');

    const gridStyle = useMemo(() => ({ height: "99%", width: "100%" }), []);

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 200,
            floatingFilter: true,
            resizable: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            filter: true,
        };
    }, []);

    const defaultExcelExportParams = useMemo(() => {
        return {
            fileName: `${activeKeyLine}.xlsx`,
            allColumns: true,
            onlySelected: false,
            sheetName: "Sheet1",
        };
    }, [activeKeyLine]);

    const defaultCsvExportParams = useMemo(() => {
        return {
            fileName: `${activeKeyLine}.csv`,
            allColumns: true,
            onlySelected: false,
        };
    }, [activeKeyLine]);

    const rowSelection = useMemo(() => {
        return {
            mode: 'singleRow',
            checkboxes: false,
            enableClickSelection: false,
        };
    }, []);

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        if (isRawListLoading) {
            params.api.showLoadingOverlay();
        } else {
            params.api.hideOverlay();
        }
    }, [isRawListLoading]);



    // Add this effect to handle loading state
    useEffect(() => {
        if (isRawListLoading) {
            setIsLoading(true);
            setLoadingMessage1(loadingMessage);
        } else {
            // Add a small delay before hiding the loading state to prevent flickering
            const timer = setTimeout(() => {
                setIsLoading(false);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isRawListLoading]);

    const CustomTotalEquipmentPanel = () => {
        return (
            <div style={{ height: '40px' }} className="ag-status-panel">
                <span style={{ paddingTop: '15px' }}>{totalTitle}: {rowData.length}</span>
            </div>
        );
    };

    const statusBar = {
        statusPanels: [
            {
                statusPanel: () => <CustomTotalEquipmentPanel />,
                align: 'left',
            },
            {
                statusPanel: 'agSelectedRowCountComponent',
                align: 'left',
            },
            {
                statusPanel: 'agFilteredRowCountComponent',
                align: 'left',
            },
        ],
    };

    const autoGroupColumnDef = useMemo(() => {
        return {
            minWidth: 200,
            pinned: "left",
        };
    }, []);

    const onSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelectModel(selectedRows);
        if (onSelectionChangedProp) {
            onSelectionChangedProp(selectedRows);
        }
    };

    const onRowDragEnd = (event) => {
        if (onRowDragEndProp) {
            onRowDragEndProp(event);
        }
    };

    const onFilterChanged = (event) => {
        if (onFilterChangedProp && gridRef.current && gridRef.current.api) {
            const filteredRows = [];
            gridRef.current.api.forEachNodeAfterFilter((node) => {
                filteredRows.push(node.data);
            });
            onFilterChangedProp(filteredRows);
        }
    };

    const getPipelineTabpanes = () => {
        return (
            <div className="h-100" style={{ paddingTop: '0px' }}>

                <div style={{ height: 'calc(100vh - 200px)', overflow: 'auto', position: 'relative' }}>
                    <div className={`ag-grid ${theme} custom-grid-theme`} style={gridStyle}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowDragManaged={true}
                            onRowDragEnd={onRowDragEnd}
                            defaultColDef={defaultColDef}
                            rowSelection={rowSelection}
                            onGridReady={onGridReady}
                            onFilterChanged={onFilterChanged}
                            sideBar={sideBar}
                            pivotMode={isPivotMode}
                            pivotPanelShow={"always"}
                            autoGroupColumnDef={autoGroupColumnDef}
                            animateRows={true}
                            onSelectionChanged={onSelectionChanged}
                            statusBar={statusBar}
                            rowHeight={40}
                            headerHeight={50}
                            defaultExcelExportParams={defaultExcelExportParams}
                            defaultCsvExportParams={defaultCsvExportParams}
                            loadingOverlayComponent={CustomLoadingCellRenderer}
                            loadingOverlayComponentParams={{
                                loadingMessage: loadingMessage1 
                            }}

                            suppressLoadingOverlay={false}
                            suppressNoRowsOverlay={true}
                            // Add these props to prevent flickering
                            suppressRowVirtualisation={false}
                            suppressColumnVirtualisation={false}
                        />
                    </div>
                </div>


            </div>
        );
    };

    return (
        <div>
            {getPipelineTabpanes()}
        </div>
    );
};

export default connect(null, null)(CommonAGGridTable);